enum modelEnum{
    AQS='AQS',
    FDS = 'FDS',
    AQS2 = 'AQS2',
    FDS2 = 'FDS2',
    TIS = 'TIS',
    PS = 'PS',
    AQS3 = 'AQS3',
    IAQ = 'IAQ'
}
export default modelEnum